import axios from 'axios';
import uniq from 'lodash.uniq';

import {AffiliateProductsResponse} from './types';

const AFFILIATE_PRODUCTS_ENDPOINT = 'api/affiliate_products';

export const getAffiliateProducts = async (
  productUids: string[],
  baseURL: string,
): Promise<AffiliateProductsResponse | undefined> => {
  if (productUids.length === 0) {
    return Promise.resolve(undefined);
  }

  return axios
    .get<AffiliateProductsResponse>(AFFILIATE_PRODUCTS_ENDPOINT, {
      baseURL: `https://${baseURL}`,
      params: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        affiliate_product_uids: uniq(productUids).join(','),
      },
    })
    .then((response) => response.data)
    .catch(() => undefined);
};
